<template>
  <div class="drawer-content">
    <Form
      ref="formItem"
      :model="formItem"
      :rules="ruleValidate"
      label-position="top"
      class="info-data"
    >
      <div v-if="fixedField.customer">
        <h4>客户</h4>
        <h2 style="margin: 4px 0 12px 0">{{ fixedField.customer.name }}</h2>
      </div>
      <FormItem label="产品" prop="product">
        <!-- <Select v-model="formItem.product">
          <Option
            v-for="option in materialList.filter((x) => x.type === 'product')"
            :value="option._id"
            :key="option._id"
            >{{ option.model }} - {{ option.name }}</Option
          >
        </Select> -->
        <div>{{ this.product.model }} - {{ this.product.name }}</div>
      </FormItem>
      <FormItem label="配方名字" prop="name">
        <Input v-model="formItem.name" placeholder="输入配方名字..." />
      </FormItem>
      <FormItem label="设为默认生产配方" prop="usedInProd">
        <i-switch v-model="formItem.usedInProd" size="large">
          <span slot="open">是</span>
          <span slot="close">否</span>
        </i-switch>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input
          v-model="formItem.remark"
          placeholder="输入备注..."
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 5 }"
        />
      </FormItem>
      <FormItem>
        <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        <Button @click="$emit('closeDrawer')" style="margin-left: 8px"
          >取消</Button
        >
      </FormItem>
    </Form>

    <div class="material-data">
      <Table
        :columns="columns"
        :data="displayData"
        border
        show-summary
        :summary-method="handleSummary"
      >
        <template slot-scope="{ row, index }" slot="ratio">
          <div v-if="row.name !== '水'">
            <InputNumber
              :max="100"
              :min="0"
              :step="0.1"
              v-model="recipeList[index].ratio"
              class="input-ratio"
            />
            <span class="percentage-append">%</span>
          </div>
          <span v-else>{{ row.ratio }}%</span>
        </template>

        <template slot-scope="{ row }" slot="deleteBtn" style="padding-left: 0">
          <Icon
            v-if="row.name !== '水'"
            type="ios-remove-circle-outline"
            class="deleteBtn"
            @click="removeMaterialfromRecipe(row._id)"
          />
        </template>
      </Table>
    </div>

    <div class="material-list-block">
      <Input
        search
        clearable
        placeholder="搜索原材料..."
        style="margin: 0 4px"
        @on-change="searchMaterial"
        v-model="searchMaterialText"
      />
      <Divider orientation="left">母液</Divider>
      <div class="material-list">
        <div
          @click="addToRecipe(i)"
          v-for="i in filteredMaterialList.filter((x) => x.type === 'semi')"
          :key="i._id"
          :class="{
            'm-cell': true,
            selected: displayData.map((e) => e._id).indexOf(i._id) !== -1,
          }"
        >
          {{ i.model }}&emsp;{{ i.name }}
        </div>
      </div>
      <Divider orientation="left">原材料</Divider>
      <div class="material-list">
        <div
          @click="addToRecipe(i)"
          v-for="i in filteredMaterialList.filter(
            (x) => x.type === 'raw' && x.usedForProduct === true
          )"
          :key="i._id"
          :class="{
            'm-cell': true,
            selected: displayData.map((e) => e._id).indexOf(i._id) !== -1,
          }"
        >
          {{ i.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "AddNewSalesRecipeDrawer",
  data() {
    return {
      product: {},
      searchMaterialText: "",
      fixedField: {
        customer: null,
        product: null,
      },
      formItem: {
        customer: "",
        name: "",
        product: "",
        usedInProd: true,
        remark: "",
      },
      ruleValidate: {
        customer: [
          { required: true, message: "请选择客户", trigger: "change" },
        ],
        product: [{ required: true, message: "请选择产品", trigger: "blur" }],
      },
      water: null,
      columns: [
        {
          title: "原材料",
          key: "name",
          render: (h, params) => {
            if (params.row.type !== "semi") return h("span", params.row.name);
            return h("span", params.row.model);
          },
        },
        {
          title: "比例",
          key: "ratio",
          slot: "ratio",
          align: "right",
          width: 130,
        },
        {
          title: " ",
          key: "deleteBtn",
          slot: "deleteBtn",
          align: "left",
          width: 40,
        },
      ],
      recipeList: [],
      materialList: [],
      searchCustomerList: [],
      filteredMaterialList: [],
    };
  },
  computed: {
    sumRatio() {
      return this.recipeList.reduce((sum, row) => sum + (row.ratio || 0), 0);
    },
    displayData() {
      if (this.water) {
        this.water.ratio = (100 - this.sumRatio).toFixed(2);
        return [...this.recipeList, this.water];
      } else {
        return [...this.recipeList];
      }
    },
  },
  methods: {
    ...mapActions({
      getMaterials: "material/getMaterialsAction",
      createRecipeSales: "recipeSales/createRecipeSalesAction",
    }),
    async searchMaterial() {
      this.filteredMaterialList = this.materialList.filter((x) => {
        return (
          (x.name && x.name.includes(this.searchMaterialText)) ||
          (x.model && x.model.includes(this.searchMaterialText))
        );
      });
    },
    handleSummary({ columns, data }) {
      return {
        name: {
          key: "name",
          value: "总和",
        },
        ratio: {
          key: "ratio",
          value: 100 + "%",
        },
        deleteBtn: {
          key: "deleteBtn",
          value: null,
        },
      };
    },
    handleSubmit(item) {
      this.$refs[item].validate(async (valid) => {
        if (valid) {
          const detail = this.displayData.map((e) => {
            return { material: e._id, ratio: e.ratio / 100 };
          });
          let newRecipe = { ...this.formItem, detail: detail };
          newRecipe.material = newRecipe.product;
          newRecipe.sales = this.fixedField._id;
          delete newRecipe.product;
          try {
            const data = await this.createRecipeSales(newRecipe);
            this.$Message.success("成功!");
            this.$emit("closeDrawer", data);
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("请先填好表格");
        }
      });
    },
    handleReset(item) {
      this.$refs[item].resetFields();
    },
    addToRecipe(m) {
      this.recipeList.push({ ...m, ratio: 0 });
    },
    removeMaterialfromRecipe(id) {
      this.recipeList = this.recipeList.filter((e) => e._id != id);
    },
    async openDrawer(_id, customer, product, recipe) {
      this.formItem.customer = customer._id;
      this.formItem.product = product._id;
      this.product = product;
      this.fixedField.customer = customer;
      this.fixedField.product = product;
      this.fixedField._id = _id;
      this.materialList = await this.getMaterials({ type: "raw,semi", limit: 99, skip: 0 });
      this.filteredMaterialList = this.materialList;
      this.water = {
        ...this.materialList.find((x) => x.type === "water"),
        ratio: 100,
      };
      if (recipe) {
        this.recipeList = [];
        // this.formItem.solidContent = recipe.solidContent;
        for (let i = 0; i < recipe.detail.length; i++) {
          if (
            recipe.detail[i].name !== "水" &&
            recipe.detail[i].name !== "材料合计"
          ) {
            this.selectMaterial(recipe.detail[i]);
          }
        }
      }
    },
    selectMaterial(material) {
      // this.newRecipe.selectedMaterials.push(material);
      if (material.hasOwnProperty("ratio")) {
        this.recipeList.push({
          ...material,
          ratio: material.ratio * 100,
        });
      } else {
        this.recipeList.push({ ...material, ratio: 0 });
      }
    },
  },
  async mounted() {
    const myDate = new Date();
    myDate.getMonth();
    myDate.getDate();
    this.formItem.name = `${myDate.getMonth() + 1}月${myDate.getDate()}日`;
  },
};
</script>

<style scoped lang="stylus">
.info-data
  padding 0 16px 0 0
  width 250px
  height 100%
  float left
  overflow-y auto

.material-data
  max-height 100%
  width 400px
  float left
  overflow-y auto

.material-list-block
  padding 0 16px 0 16px
  height 100%
  width 318px
  // padding: 0 8px;
  float left
  overflow-y auto

.material-list
  display flex
  flex-wrap wrap
  align-content flex-start
  overflow-y auto
  margin-top 8px

.m-cell
  padding 8px
  margin 4px
  border 1px solid lightgray
  border-radius 4px
  cursor pointer

  &:hover
    color #0168fa
    border 1px solid #0168fa
    box-shadow 0 2px 4px rgba(209, 230, 250, 1)
    transition 0.2s

.selected
  color lightgray
  cursor default
  pointer-events none

.input-ratio
  width 75px
  float left
  text-align right
  margin-right 4px

.percentage-append
  float right
  line-height 32px
  height 32px

.sumratio
  line-height 32px
  font-weight 500
  font-size 20px
  margin-right 4px

.sumratio-alert
  color red

.sumratio-nice
  color green

.deleteBtn
  cursor pointer

  &:hover
    color red
</style>
